module.exports = __webpack_public_path__ + "static/media/info-icon.f315360e.svg";